
export default function Hero() {
  return (
    <section className="relative w-full py-8 px-6 lg:px-12 bg-gradient-to-r from-rose-50 via-white to-rose-50">
      <div className="container mx-auto">
        <div className="relative h-32 lg:h-40 rounded-2xl overflow-hidden shadow-lg bg-gradient-to-r from-[#F5E6E0] via-[#FAE8E4] to-[#F5E6E0]">
          {/* Éléments décoratifs */}
          <div className="absolute top-4 left-8 w-20 h-20 bg-rose-200/30 rounded-full blur-2xl"></div>
          <div className="absolute bottom-4 right-12 w-32 h-32 bg-rose-300/20 rounded-full blur-3xl"></div>
          <div className="absolute top-1/2 left-1/4 w-2 h-2 bg-rose-400/40 rounded-full"></div>
          <div className="absolute top-1/3 right-1/3 w-1.5 h-1.5 bg-rose-300/50 rounded-full"></div>
          
          <div className="absolute inset-0 flex items-center justify-center px-8 lg:px-16">
            <div className="text-center max-w-3xl">
              <p className="text-gray-800 text-xl lg:text-3xl font-light leading-tight">
                <span className="font-semibold">"Retrouvez une peau harmonieuse et scintillante"</span>
              </p>
              <p className="text-gray-600 text-sm lg:text-base mt-2 font-light">
                – celle que les crèmes de pharmacie n'ont jamais pu vous redonner ✨
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
